module.exports = __webpack_public_path__ + "static/media/Cyera_Logo_Inverted.546ae8da.png";